import React, { useRef } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInCloseProximityToViewport } from '../../../utils/useIntersectionObserver';
import Image from '../../generic/Image';
import { ScrollToSeeMoreFullScreen } from '../../generic/ScrollToSeeMore';
import { Fixed } from '../ScrollProgression';
import styles from './index.module.scss';

/**
 * PageHeading is a component that superimposes a semitransparent curtain-like element
 * @param {object} props PageHeading props: {title: <string>, description: <string>, image: <image object> - CMS image type}
 */
export default function PageHeading({ heading, description, image }) {
  let { intersectionRef, outOfViewport } = useOutOfViewport();
  let springProps = useSpring({
    from: {
      opacity: 0,
      transform: `translateY(100%)`,
    },
    opacity: 1,
    transform: `translateY(0)`,
    delay: 500,
  });

  return (
    <>
      <Fixed className={styles.restrictedImage} deactivateFixed={outOfViewport}>
        <Image fluid={image.fluid} alt={image.description} />
      </Fixed>
      <div className={styles.pageHeading} ref={intersectionRef}>
        <animated.div style={springProps} className={styles.heading}>
          <h1>{heading}</h1>
          <p>{description}</p>
        </animated.div>
        <div className={styles.overlay}>
          <ScrollToSeeMoreFullScreen className={styles.scrollToSeeMore} />
        </div>
      </div>
    </>
  );
}

function useOutOfViewport() {
  let intersectionRef = useRef(null);
  let outOfViewport = !useInCloseProximityToViewport(intersectionRef);
  return { intersectionRef, outOfViewport };
}
